// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"baa2a1ae","895":"6728c191"}[chunkId] + ".chunk.js";
};